import { render, staticRenderFns } from "./footerLeft.vue?vue&type=template&id=adcf34c6&scoped=true&"
import script from "./footerLeft.vue?vue&type=script&lang=js&"
export * from "./footerLeft.vue?vue&type=script&lang=js&"
import style0 from "./footerLeft.vue?vue&type=style&index=0&id=adcf34c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcf34c6",
  null
  
)

export default component.exports